<template>
  <div class="p-col-12">
    <page-header title="forms.text-fragment.title"/>
    <form @submit.prevent="save">

      <card :header="$t('forms.text-fragment.card-title-text-fragment')" class="p-col-12">
        <coff-input-text v-model="form.name" label="forms.text-fragment.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
        <coff-input-text v-model="form.code" label="forms.text-fragment.code" class="p-col-12 p-md-6 p-lg-4" :error="validation.code" />
        <coff-input-text v-model="form.fragmentGroup" label="forms.text-fragment.group" class="p-col-12 p-md-6 p-lg-4"/>
        <coff-input-radio v-model="form.active" @update="forceUpdateField('active', $event)" :options="options" label="forms.text-fragment.isActive" class="p-col-12 p-md-4 p-lg-2" :error="validation.active"/>
        <coff-input-text-editor v-model="form.content" label="forms.text-fragment.content" class="p-col-12"/>
        <div class="p-col-12">
          <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
        </div>
      </card>

    </form>
  </div>
</template>

<script>

import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import TextFragmentBusiness from "@/business/TextFragmentBusiness";
import PageHeader from "@/components/page/PageHeader";
import EventBus from "@/commons/EventBus";

export default {
  name: "TextFragmentForm",
  components: {PageHeader},
  data(){
    return {
      form: {},
      validation: {
        name: false,
        code: false,
        active: false,
        content: false,
      },
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  async mounted(){
    const id = this.$route.params.id;
    if(id){
      EventBus.loadingPage(true);
      this.form =  {... await TextFragmentBusiness.getById(id)};
      EventBus.loadingPage(false);
    }
  },

  methods: {

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        const response = await TextFragmentBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.form.id = response.id;
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    forceUpdateField(field, value){
      this.$set(this.form, field, value);
    },

  }

}
</script>

<style scoped>

</style>